<template>
  <b-modal
      ref="modal"
      v-bind="$attrs"
      :id="id"
      :title="modalTitle"
      ok-only
      ok-title="Simpan"
      @ok="handleOkButton"
      size="lg"
      title-class="font-18"
  >
    <b-form-checkbox
        style="margin-left: 10px;"
        name="checkboxSelectAll"
        v-model="selectedAll"
        @change="toggleSelectAll"
    >
      <b>{{ selectedAll ? 'Un-select All' : 'Select All' }}</b>
    </b-form-checkbox>
    <b-table-simple :key="items.map(item => item.purchase_item_id || item.purchase_order_id).join(',')" responsive>
      <b-thead>
        <b-tr>
          <b-th>{{ `${this.lodash.startCase(this.$t('trips.choose'))}` }}</b-th>
          <b-th>{{ `${this.lodash.startCase('no')}` }}</b-th>
          <b-th>{{ `${this.lodash.startCase(this.$t('purchase_items.quantity'))}` }}</b-th>
          <b-th>{{ `${this.lodash.startCase(this.$t('purchase_items.available_quantity'))}` }}</b-th>
          <b-th>{{ `${this.lodash.startCase(this.$t('purchase_items.size'))}` }}</b-th>
          <b-th>{{ `${this.lodash.startCase(this.$t('purchase_items.unit_price'))}` }}</b-th>
          <b-th>{{ `${this.lodash.startCase(this.$t('purchase_items.total_price'))}` }}</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(item, index) in tableItems" v-bind:key="index" :variant="item._rowVariant">
          <template v-if="!item.$purchaseOrder">
            <b-td>
              <b-form-checkbox
              :id="`purchase-item-checkbox-${index}`"
              v-model="item.$selected"
              :disabled="item.disabled"
              />
            </b-td>
            <b-td class="text-start">{{item._index + 1}}</b-td>
            <!-- <b-td>{{ lodash.startCase( item.fund) }}</b-td> -->
            <b-td class="text-end">{{ $numeral(item.quantity).format('0,0.[000]') }}</b-td>
            <b-td class="text-end">{{ $numeral(item.available_quantity).format('0,0.[000]') }}</b-td>
            <b-td class="text-end">{{ $numeral(item.size).format('0,0.[000]') }}</b-td>
            <b-td class="text-end">{{ $numeral(item.unit_price).format('$ 0,0.[000]') }}</b-td>
            <b-td class="text-end">{{ $numeral(item.total_price).format('$ 0,0.[000]') }}</b-td>
          </template>
          <template v-else>
            <b-td>
              <b-form-checkbox
                  :id="`purchase-order-checkbox-${index}`"
                  v-model="item.$selected"
                  :disabled="item.disabled"
                  @change="purchaseOrderChecked($event, item)"
              />
            </b-td>
            <b-td colspan="7"><b>{{
                `${lodash.startCase($t('purchase_orders.singular'))} ID ${item.purchase_order_id} (${item.product.name})`
              }}</b></b-td>
          </template>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </b-modal>
</template>

<script>
export default {
  name: "modal-select-item-purchase-order",
  props: {
    defaultValue: {type: Array, default() { return [] }},
    fields: { type: Array, default: () => [] },
    id: {type: String, required: true},
    items: {type: Array, default() { return [] }},
    modalTitle: { type: String, default: () => this.lodash.startCase(this.$t('models.singular'))},
    selectedPurchaseItems: { type: Array, default: () => [] }
  },
  data() {
    return {
      tableItems: this.lodash.cloneDeep(this.items),
      loading: false,
      isValid: true,
      errors: {},
      selected: [],
      selectedAll: null
    }
  },
  watch: {
    tableItems: function (val, oldVal) {
      if (!this.lodash.isEqual(val, oldVal)) {
        if (val.filter(v => v.$selected).length === 0) {
          this.selectedAll = false
        } else if (val.filter(v => !v.$selected) === 0) {
          this.selectedAll = true
        }
      }
    },
    defaultValue(newVal) {
      if (newVal.length)
        this.selected = [...newVal]
    }
  },
  mounted() {
    this.selected = [...this.defaultValue]
  },
  methods: {
    purchaseOrderChecked(event, tableItem) {
      this.tableItems = this.tableItems.map(item => {
        if (item.$checkbox && !item.disabled && !item.$purchaseOrder && item.purchase_order_id === tableItem.purchase_order_id) {
          item.$selected = event
        }

        return item
      })
    },
    toggleSelectAll(payload) {
      this.tableItems = this.tableItems.map(item => {
        if(item.$purchaseOrder){
          item.$selected = item.$checkbox && !item.disabled ? payload : false
          return item;
        }
        const storedItem = this.items.find(i => i.id === item.id)
        return {
          ...storedItem,
          $selected: item.$checkbox && !item.disabled ? payload : false
        };
      })
      // this.tableItems = this.items.map(item => ({...item, $selected: item.$checkbox && !item.disabled ? payload : false}))
    },
    handleOkButton() {
      this.$emit('update:items', this.lodash.cloneDeep(this.tableItems.filter(item => !item.$purchaseOrder)))
      this.$emit('onPurchaseItemSelected', this.selected)
      this.$refs.modal.hide()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep{
  .custom-checkbox .custom-control-label::before {
    border-radius: 0.25rem;
  }
  //.custom-checkbox {
  //  .custom-control-label::before {
  //    border-radius: 0.25rem;
  //  }
  //}
}
</style>
